<div class="row input-header">
    <div class="col-6 d-flex">
        <img class="akit-logo" src="./assets/algebrakit-logo.png">
    </div>
    <div class="col-6 d-flex justify-content-end">

        <div class="dropdown">
            <a class="btn btn-secondary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{getTitle()}}
            </a>
          
            <ul class="dropdown-menu">
              <li *ngFor="let p of pages"><a class="dropdown-item" (click)="pageClicked(p.id)">{{p.name}}</a></li>
            </ul>
        </div>        

    </div>
</div>
